import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSwipeable } from 'react-swipeable';
import { GET, getQuery, makeApiCal } from '../../util';
import './TopLayout.css';
import Navbar from './Navbar/Navbar';
import ContentInt from './ContentInt.js';
import PageTopHeader from "../PageTopHeader/PageTopHeader";
import {
  tutorDetailsSharedConfig,
  globalColors,
  resolveTutorDetailsSharedAsset,
} from './tutorDetailsSharedConfig';

function TopLayout(props){
  const { data } = props;
  const history = useHistory();
  const location = useLocation();
  let navRef = useRef();
  let drawerRef = useRef();
  const [apiData, setApiData] = useState();
  const sharedImages = tutorDetailsSharedConfig.images || {};
  const sharedText = tutorDetailsSharedConfig.text || {};
  const pageLayoutStyle = {
    '--tutor-details-page-background': `url(${resolveTutorDetailsSharedAsset(sharedImages.page_background)})`,
    '--tutor-details-navbar-background': globalColors.accent_color || '#E35C22',
    '--tutor-details-header-accent-text': globalColors.accent_color || '#E35C22',
    '--tutor-details-points-badge-text': globalColors.accent_color || '#E35C22',
    '--tutor-details-warm-text': globalColors.subheading || 'rgba(108, 39, 24, 1)',
    '--tutor-details-progress-track': globalColors.progress_background || 'rgba(222, 208, 198, 1)',
    '--tutor-details-progress-fill': globalColors.accent_color || '#E35C22',
    '--tutor-details-body-text': globalColors.body_text || '#253050',
    '--tutor-details-inverse-text': globalColors.white_text || '#fff',
  };

  const [nav, setNav] = React.useState(true);

  const navBar = [

      ...(apiData?.overview || true
          ? [
              {
                  key: 'overview',
                  name: sharedText.tab_labels?.overview || 'OVERVIEW',
                  drawerColor: '#1E3D7E',
              },
          ]
          : []),

      ...(apiData?.rankingsPage
			? [
					{
						key: 'leaderboard',
						name: sharedText.tab_labels?.leaderboard || 'LEADERBOARD',
						drawerColor: '#1E3D7E',
					},
			  ]
			: []),

      ...(apiData?.overview || false
          ? [
              {
                  key: 'star',
                  name: sharedText.tab_labels?.star || 'STAR',
                  drawerColor: '#1E3D7E',
              },
          ]
          : []),

    ...(apiData?.peakDayCard || false
          ? [
              {
                key: 'milestones',
                name: sharedText.tab_labels?.milestones || 'MILESTONE',
                drawerColor: 'rgba(28, 55, 103, 1)',
              },
            ]
          : []),

     ...(apiData?.statCard
          ? [
              {
                key: 'tasks',
                name: sharedText.tab_labels?.tasks || 'TASKS',
                drawerColor: '#1E3D7E',
              },
            ]
            : []),


    ...(apiData?.toolsPage
      ? [
          {
            key: 'tools',
            name: sharedText.tab_labels?.tools || 'TOOLS',
            drawerColor: '#1E3D7E',
          },
        ]
      : []),
    ...(apiData?.checklist
      ? [
          {
            key: 'checklist',
            name: sharedText.tab_labels?.checklist || 'CHECKLIST',
            drawerColor: '#1E3D7E',
          },
        ]
      : []),
  ];
  useEffect(() => {
  }, [navBar]);

  const [activeTab, updateActiveTab] = useState();
  const [activeIndex, updateActiveIndex] = useState();
  const [loading, updateLoading] = useState(true);
  const [err, catchError] = useState(false);

  const getData = () => {
    const action = {
      method: GET,
      route: 'v1/campaign/detailPage',
      storeData: setApiData,
      catchError: catchError,
    };
    makeApiCal(action);
  };

  useEffect(() => {
    getData();
    const tab = props?.match?.params?.tab;
    const scroller = new Promise((resolve, reject) => {
      setTimeout(() => {
        scrollNav(3);
        resolve();
      }, 1000);
    });

    scroller
      .then(() => {
        if (tab !== 'checklist') {
          setTimeout(() => {
            scrollNav(-3);
          }, 500);
        }
      })
      .then(() => {
        if (tab === 'milestones' || tab === 'tools') {
          setTimeout(() => {
            scrollNav(3);
          }, 1000);
        }
      });
  }, []);

  useEffect(() => {
    const tab = props?.match?.params?.tab;
    if (apiData) {
      updateLoading(false);
      if (tab) {
        let tabIndex = navBar.findIndex((item) => item?.key === tab);
        updateActiveIndex(tabIndex);
        updateActiveTab(navBar[tabIndex]);
        //navBar?.filter((item) => item.key === tab)
      }
    }
  }, [apiData, err]);


  useEffect(() => {
    let tabName = history?.location?.pathname?.split('/')[3];
    let tabIndex = navBar.findIndex((item) => item?.key === tabName);
    updateActiveTab(navBar[tabIndex]);
    updateActiveIndex(tabIndex);
  }, [location]);

  const changeTab = (value) => {
    if (activeIndex === navBar?.length - 1 && value > 0) {
      history.push(`${navBar[0].key}`);
      // updateActiveTab(navBar[0]);
      scrollNav(-3);
    } else if (activeIndex === 0 && value < 0) {
      history.push(`${navBar[navBar?.length - 1].key}`);
      // updateActiveTab(navBar[navBar?.length - 1]);
      scrollNav(3);
    } else {
      history.push(`${navBar[activeIndex + value].key}`);
      // updateActiveTab(navBar[activeIndex + value]);
      scrollNav(value);
    }
  };
  const scrollNav = (value) => {
    const scrollWidth = window?.innerWidth * (Math.abs(value) * 0.34);
    if (value > 0) {
      navRef?.current?.scrollBy(scrollWidth, 0);
    } else if (value < 0) {
      navRef?.current?.scrollBy(-scrollWidth, 0);
    }
  };
  const swipeActions = useSwipeable({
    onSwipedLeft: () => changeTab(1),
    onSwipedRight: () => changeTab(-1),
  });

    return(
        <div className="page-layout" style={pageLayoutStyle}>
            <Navbar
                data={navBar}
                activeTab={activeTab}
                updateActiveTab={updateActiveTab}
                scrollNav={scrollNav}
                ref={navRef}
            />
            {activeTab?.key !== "overview" &&
                <PageTopHeader
                    data={apiData?.campaignOrg}
                ></PageTopHeader>
            }
            <ContentInt
                data={apiData}
                activeTab={activeTab}
                swipeActions={swipeActions}
                callMainApi={getData}
                setNav={setNav}
                scrollNav={scrollNav}
            />
        </div>
    )
}

export default TopLayout;
